import {createTheme} from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    formLabel: React.CSSProperties;
    pageTitle: React.CSSProperties;
  }
  
  interface TypographyVariantsOptions {
    formLabel: React.CSSProperties;
    pageTitle: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    formLabel: true;
    pageTitle: true;
  }
}

const palette = createPalette({
  primary: {
    main: "#2563EB",
    contrastText: "#fff",
  },
  secondary: {
    main: "#141C29",
  },
  background: {default: "#F8FAFC", paper: "#fff"},
});

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, Noto Sans JP, sans-serif",
    formLabel: {
      color: "text.secondary",
      fontWeight: "bold",
      fontSize: 13
    },
    pageTitle: {
      fontWeight: 700,
      fontSize: 28,
      borderLeft: "6px solid",
      borderColor: palette.primary.main,
      paddingLeft: 16,
      marginBottom: 8,
      color: palette.secondary.main,
      letterSpacing: 0.5,
      borderRadius: 2,
      textShadow: '0px 1px 1px rgba(0,0,0,0.05)',
    },
  },
  components: {
    MuiCard: {
      defaultProps: {
        elevation: 0,
        variant: "outlined",
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiTypography: {
      defaultProps: {
        component: "p",
      },
    },
  },
  palette,
});

export default theme;
